import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import classnames from 'classnames';
import { whitelistStyles } from "../hoc";
import { TextTransformService } from "../../../services";
var DateTime = createComponent({
  displayName: 'DateControl',
  propTypes: {
    timeZone: PropTypes.string.isRequired,
    date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
    format: PropTypes.string,
    isRelative: PropTypes.bool,
    isRelativeAllowFuture: PropTypes.bool
  },
  defaultProps: {
    format: 'LLL',
    isRelative: false,
    isRelativeAllowFuture: false
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(_ref) {
    var timeZone = _ref.timeZone,
        isRelative = _ref.isRelative,
        isRelativeAllowFuture = _ref.isRelativeAllowFuture,
        date = _ref.date,
        format = _ref.format,
        isInverted = _ref.isInverted,
        style = _ref.style;
    var displayDate = TextTransformService.dateTime(date, timeZone, {
      format: format,
      isRelative: isRelative,
      isRelativeAllowFuture: isRelativeAllowFuture
    });
    var className = classnames({
      ck: true,
      'date-time': true,
      inverted: isInverted
    });
    return /*#__PURE__*/React.createElement("span", {
      className: className,
      style: style
    }, displayDate);
  }
});
export default whitelistStyles()(DateTime);
//# sourceMappingURL=index.js.map